import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import EnvConfig from 'env.config';

const contains = (intl, messageId) => intl && !!intl.messages[messageId];

const CookieBanner = ({ intl }) => {
  const [show, setShow] = useState(true);

  const setCookies = () => {
    document.cookie = `${ EnvConfig.cookieConsentName }=true; path=/; expires=Fri, 01 Jan 2038 00:00:00 GMT; samesite=lax`;
    setShow(false);
  };

  const getCookieLinks = () => {
    const linkPreText = 'You also agree to the terms detailed in the policies found at ';
    const privacyLink = contains(intl, 'footerPage.privacy');
    const termsOfUseLink = contains(intl, 'footerPage.termsOfUse');
    const cookiesLink = contains(intl, 'footerPage.cookies');
    const links = (privacyLink ? 1 : 0) + (termsOfUseLink ? 1 : 0) + (cookiesLink ? 1 : 0);
    if (links === 0) {
      return '';
    }
    return <React.Fragment>
      { `${ linkPreText }${ (links === 1) ? 'this link' : 'these links' }: ` }
      { privacyLink && <a href="/links/privacy" target="_blank"> Privacy &amp; GDPR</a> }
      { privacyLink && links > 1 ? ', ' : '' }
      { termsOfUseLink && <a href="/links/termsOfUse" target="_blank"> Terms of Use</a> }
      { termsOfUseLink && links > 1 ? ' and ' : '' }
      { cookiesLink && <a href="/links/cookies" target="_blank"> Cookies</a> }.
    </React.Fragment>;
  };

  return (
    show && <React.Fragment> <div className="cookie-banner">
      <div className="cookie-content">
        <div className="close-cookie">
          <button className="close-cookie-button" aria-label="close-cookie-button" type="button" onClick={ () => setCookies() } onKeyDown={ () => setCookies() }>
            <FontAwesomeIcon
              icon="times"
              className="icon"
            />
          </button>
        </div>
        <div className="cookie-message">
          We use cookies to help give you the best possible experience on our website. By closing this message or continuing to browse our site you are consenting to the use of cookies. { getCookieLinks() }
        </div>
      </div>
    </div>
    </React.Fragment>
  );
};

CookieBanner.propTypes = {
  intl: PropTypes.shape({
    messages: PropTypes.any
  }).isRequired
};

export default injectIntl(CookieBanner);
